import React from "react";
import { Button } from "react-bootstrap";
import {
  FaBullhorn,
  FaUsers,
  FaBuilding,
  FaBook,
  FaArrowRight,
} from "react-icons/fa";
import { FaFileInvoice, FaGraduationCap } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";


function Sidebar({ expanded, setExpanded, selected }) {
  const navigate = useNavigate();

  const handleNavigation = (route) => {
    navigate(route);
  };

  const [t] = useTranslation("navbar")
  const authInfoString = localStorage.getItem('authInfo');
  const authInfo = authInfoString ? JSON.parse(authInfoString) : {};
  const role = authInfo.rol;

  return (
    <div className={`navbar-container ${!expanded ? 'navbar-not-expanded' : ''}`}>
      <div className="navbar-static">
        <Button onClick={() => { setExpanded(!expanded); }}
          className="mt-3 navbar-arrow">
          <div className={!expanded ? 'no-rotate' : 'rotate-clockwise'}>
            <FaArrowRight size={25} />
          </div>
        </Button>

        {/* Si role es 'responsible', renderiza el botón de Casos */}
        {(role === 'responsible' || role === "adminResponsible") && (

          <Button className={`navbar-button ${expanded ? 'navbar-button-expanded' : ''} ${selected === 'Casos' ? 'navbar-button-selected custom-shadow' : ''}`} onClick={() => handleNavigation("/incidents")}>
            <span className={`${expanded ? 'navbar-icon-text-expanded' : 'navbar-icon-text'}`} ><FaBullhorn className={`${expanded ? 'navbar-icon-expanded' : 'navbar-icon'} ${selected === 'Casos' ? 'navbar-icon-active' : ''}`} size={25} /> {expanded && <span className={`nabvar-expanded-text ${t("navbar.incidents").length > 11 && 'nabvar-expanded-text-scrolling'}`}>{t("navbar.incidents")}</span>}</span>
          </Button>
        )}

        {/* Si role es 'admin', renderiza los botones de Usuarios y Empresas */}
        {(role === 'admin' || role === "adminResponsible") && (
          <>

            <Button className={`navbar-button ${expanded ? 'navbar-button-expanded' : ''} ${selected === 'Usuarios' ? 'navbar-button-selected custom-shadow' : ''}`} onClick={() => handleNavigation("/users")}>
              <span className={`${expanded ? 'navbar-icon-text-expanded' : 'navbar-icon-text'}`} ><FaUsers className={`${expanded ? 'navbar-icon-expanded' : 'navbar-icon'} ${selected === 'Usuarios' ? 'navbar-icon-active' : ''}`} size={25} /> {expanded && <span className={`nabvar-expanded-text ${t("navbar.users").length > 11 && 'nabvar-expanded-text-scrolling'}`}>{t("navbar.users")}</span>}</span>
            </Button>

            <Button className={`navbar-button ${expanded ? 'navbar-button-expanded' : ''} ${selected === 'Empresas' ? 'navbar-button-selected custom-shadow' : ''}`} onClick={() => handleNavigation("/companies")}>
              <span className={`${expanded ? 'navbar-icon-text-expanded' : 'navbar-icon-text'}`} ><FaBuilding className={`${expanded ? 'navbar-icon-expanded' : 'navbar-icon'} ${selected === 'Empresas' ? 'navbar-icon-active' : ''}`} size={25} /> {expanded && <span className={`nabvar-expanded-text ${t("navbar.companies").length > 11 && 'nabvar-expanded-text-scrolling'}`}>{t("navbar.companies")}</span>}</span>
            </Button>

            <div className="navbar-bottom-button">
              <hr className="navbar-bottom-bar" />


              <Button className={`navbar-button ${expanded ? 'navbar-button-expanded' : ''} ${selected === 'Suscripción' ? 'navbar-button-selected custom-shadow' : ''}`} onClick={() => handleNavigation("/subscription")}>
                <span className={`${expanded ? 'navbar-icon-text-expanded' : 'navbar-icon-text'}`} ><FaFileInvoice className={`${expanded ? 'navbar-icon-expanded' : 'navbar-icon'} ${selected === 'Suscripción' ? 'navbar-icon-active' : ''}`} size={25} /> {expanded && <span className={`nabvar-expanded-text ${t("navbar.sub").length > 11 && 'nabvar-expanded-text-scrolling'}`}>{t("navbar.sub")}</span>}</span>
              </Button>
            </div>
          </>
        )}

        <Button className={`navbar-button ${expanded ? 'navbar-button-expanded' : ''} ${selected === 'Formación' ? 'navbar-button-selected custom-shadow' : ''}`} onClick={() => handleNavigation("/formation")}>
          <span className={`${expanded ? 'navbar-icon-text-expanded' : 'navbar-icon-text'}`} ><FaGraduationCap className={`${expanded ? 'navbar-icon-expanded' : 'navbar-icon'} ${selected === 'Formación' ? 'navbar-icon-active' : ''}`} size={25} /> {expanded && <span className={`nabvar-expanded-text ${t("navbar.formation").length > 11 && 'nabvar-expanded-text-scrolling'}`}>{t("navbar.formation")}</span>}</span>
        </Button>

        <Button className={`navbar-button ${expanded ? 'navbar-button-expanded' : ''} ${selected === 'Normativa' ? 'navbar-button-selected custom-shadow' : ''}`} onClick={() => handleNavigation("/legal")}>
          <span className={`${expanded ? 'navbar-icon-text-expanded' : 'navbar-icon-text'}`} ><FaBook className={`${expanded ? 'navbar-icon-expanded' : 'navbar-icon'} ${selected === 'Normativa' ? 'navbar-icon-active' : ''}`} size={25} /> {expanded && <span className={`nabvar-expanded-text ${t("navbar.legal").length > 11 && 'nabvar-expanded-text-scrolling'}`}>{t("navbar.legal")}</span>}</span>
        </Button>

      </div>
    </div>
  );
}

export default Sidebar;
